module.exports = __webpack_public_path__ + "img/btnBack.a2b78770.png";